import type { SupplyReport } from '#shared/types';
import { SectionShell } from './SectionShell';
import { ConsumedCard, ConsumptionTableCard, ExpiringCard, HeaviestUseCard } from './SupplyCards';
import { topConsumers } from './report.logic';
import { useAnalyticsFilters } from './useAnalyticsFilters';
import { useAnalyticsSection } from './useAnalyticsSection';

/**
 * What the shelf cost, and what is about to be thrown away.
 *
 * The cost figures are derived from the stock ledger and never typed in, which
 * is why no expense category covers reagents — entering it as well would count
 * the same rupee twice. The screen says so on the tile.
 */
export function SupplyPage() {
  const filters = useAnalyticsFilters('supply');
  const { data, loading, error } = useAnalyticsSection<SupplyReport>('supply', filters);

  const heaviest = data ? topConsumers(data.consumption) : [];

  return (
    <SectionShell
      section="supply"
      filters={filters}
      data={data}
      loading={loading}
      error={error}
      metrics={data?.headline}
      empty={data !== undefined && data.consumption.length === 0}
      emptyMessage="No reagents have been recorded yet."
    >
      {data && (
        <div className="c-an__grid">
          <ConsumedCard series={data.series} />
          {heaviest.length > 0 && <HeaviestUseCard consumers={heaviest} />}
          <ExpiringCard expiring={data.expiring} />
          <ConsumptionTableCard consumption={data.consumption} />
        </div>
      )}
    </SectionShell>
  );
}
